export default __webpack_public_path__ + "static/agc-adb66031c393394492d2d15c433aacae.png";